/** 0033612345678 ou +33612345678 -> 06 12 34 56 78 (les numéros étrangers restent tels quels). */
export function numeroLisible(numero) {
    const n = (numero || "").replace(/^\+33|^0033/, "0");
    return /^0\d{9}$/.test(n) ? n.replace(/(\d\d)(?=\d)/g, "$1 ") : (numero || "Numéro masqué");
}

/** 75 -> « 1 min 15 s » */
export function dureeLisible(secondes) {
    if (!secondes) {
        return "—";
    }
    const minutes = Math.floor(secondes / 60);
    return (minutes ? minutes + " min " : "") + (secondes % 60) + " s";
}
